export default "__VITE_ASSET__Bf$qYDzc__"